import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert,
  AlertTitle,
} from '@mui/material';
import { adminService } from '@/services/api';

interface UserStats {
  username: string;
  last_login: string;
  job_counts: {
    colabfold: number;
    rfdiffusion: number;
    esmif: number;
    optimize: number;
  };
}

const UsageStats: React.FC = () => {
  const [stats, setStats] = useState<UserStats[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const data = await adminService.getUsageStats();
        setStats(data);
        setError(null);
      } catch (error) {
        console.error('Error fetching usage stats:', error);
        setError('Failed to load usage statistics');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg">
        <Box mt={4}>
          <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            {error}
          </Alert>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg">
      <Box mb={4} mt={3}>
        <Typography variant="h4" component="h1" gutterBottom>
          Usage Statistics
        </Typography>

        <Paper>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Username</TableCell>
                  <TableCell>Last Login</TableCell>
                  <TableCell align="right">ColabFold Jobs</TableCell>
                  <TableCell align="right">RF Diffusion Jobs</TableCell>
                  <TableCell align="right">ESM-IF Jobs</TableCell>
                  <TableCell align="right">Optimization Jobs</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stats.map((user) => (
                  <TableRow key={user.username}>
                    <TableCell>{user.username}</TableCell>
                    <TableCell>
                      {new Date(user.last_login).toLocaleString()}
                    </TableCell>
                    <TableCell align="right">{user.job_counts.colabfold}</TableCell>
                    <TableCell align="right">{user.job_counts.rfdiffusion}</TableCell>
                    <TableCell align="right">{user.job_counts.esmif}</TableCell>
                    <TableCell align="right">{user.job_counts.optimize}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </Container>
  );
};

export default UsageStats; 